<div class="error-component">
  <h3 *ngIf="title">{{ title }}</h3>
  <div class="error-message" *ngIf="message">
    {{ message | ellipsis : MAX_CHARACTER_COUNT }}
  </div>
</div>
